import React from 'react';
import { Button } from 'react-bootstrap';
import history from '../../history';
import SecurityBoxControls from '../SecurityBoxControls';
import SecurityBoxLink from '../SecurityBoxLink';
import ForgotPasswordControl from './ForgotPasswordControl';

export default ({ forgotPassText, linkText, submitText, registrationLink = '/registration' }) => {
  return (
    <div style={{ width: 307, marginLeft: 50, marginTop: 30 }}>
      <SecurityBoxControls>
        <ForgotPasswordControl onLinkClick={() => history.push('/reset-password')} forgotPassText={forgotPassText} />
        <div style={{ float: 'right' }}>
          <Button name="loginUserButton" type="submit" bsStyle="primary" style={{ width: 120 }}>
            {submitText}
          </Button>
        </div>
      </SecurityBoxControls>
      <div style={{ textAlign: 'center', marginTop: 25 }}>
        <SecurityBoxLink name="registrationLink" linkUrl={registrationLink} text={linkText} />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/login/LoginSecurityBoxControls.jsx